//Group Request
export const FETCH_GROUP_USERS_REQUEST = "FETCH_GROUP_USERS_REQUEST";
export const FETCH_GROUP_USERS_SUCCESS = "FETCH_GROUP_USERS_SUCCESS";
export const FETCH_GROUP_USERS_FAILURE = "FETCH_GROUP_USERS_FAILURE";